module.exports = __webpack_public_path__ + "static/componentspage-18381325bd76f82e114285a60825e593.png";